<template>
  <div :class="elementClass">
    <div :class="elementInner" ref="inner">
      <textarea
        @input="input($event)"
        ref="textarea"
        style="height: 100%"
        @focus="focus"
        :disabled="disabled"
        @blur="blur"
        :value.prop="tempValue"
        rows="5"
        :required="required"
      >
      </textarea>
      <div class="floating-placeholder" @click="focusInput">{{ placeholder }} <span class="color-red" v-if="required">*</span></div>
      <div class="backline"></div>
      <div class="line"></div>
    </div>
    <div v-if="!noMessage" :class="messageClass">{{ message }}</div>
  </div>
</template>

<script>
import { multifieldClass } from "../prefix";
import OverlayScrollbars from "overlayscrollbars";
import "overlayscrollbars/css/OverlayScrollbars.css";
export default {
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    value: {
      default: "",
      type: String,
    },
    placeholder: {
      default: "",
      type: String,
    },
    message: {
      default: "",
      type: String,
    },
    noMessage: {
      default: false,
      type: Boolean,
    },
    label: {
      default: false,
      type: Boolean,
    },
    required: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      isFocus: false,
      tempValue: this.value,
    };
  },
  computed: {
    elementClass() {
      return multifieldClass;
    },
    elementInner() {
      return (
        "inner" +
        (this.isFocus ? " focus" : "") +
        (this.value || this.isFocus ? " float" : "") +
        (this.disabled ? " disabled" : "") +
        (this.label ? " label" : "")
      );
    },
    messageClass() {
      return "message" + (this.isFocus ? " focus" : "");
    },
  },
  mounted() {
    this.$nextTick(() => {
      OverlayScrollbars(this.$refs.textarea, {});
    });
  },
  methods: {
    blur() {
      this.isFocus = false;
      this.$emit("blur");
    },
    updateValue(value) {
      this.tempValue = value;
      this.$emit("input", value);
    },
    focus() {
      this.isFocus = true;
      this.$emit("focus", this.$refs.inner);
    },
    focusInput() {
      this.$refs.textarea.focus();
      this.focus();
    },
    input(e) {
      return this.updateValue(e.target.value);
    },
  },
  watch: {
    value(val) {
      this.tempValue = val;
    },
  },
};
</script>

<style lang="scss">
@import "../scss/import.scss";
$element: $prefix + "-multifield";

#{$element} {
  padding-bottom: 4px;
  .inner {
    z-index: 2;
    padding-left: 16px;
    padding-top: 18px;
    overflow: hidden;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-radius: 4px;
    padding-bottom: 18px;
    // padding-right: 18px;
    border: 1px solid $color-grey-300;

    .os-padding.os-text-inherit {
      margin-right: 18px;
    }

    textarea {
      width: 100%;
      border: 0;
      margin: 0;
      box-shadow: none;
      font-size: 12px;
      line-height: 18px;
      outline: none;
      background: transparent;
      letter-spacing: -0.09px;
      display: block;
      cursor: text;
      @include transition(all 0.15s $animation-deceleration-curve-timing-function);
    }

    .floating-placeholder {
      position: absolute;
      top: 16px;
      left: 16px;
      width: 100%;
      height: 100%;
      font-size: 12px;
      line-height: 20px;
      color: $color-grey-500;
      font-weight: 500;
      @include transition(all 0.15s $animation-acceleration-curve-timing-function);
      @include transform-origin((0));
      @include unselectable();
    }

    &:hover {
      .floating-placeholder {
        color: $color-grey-500;
      }
    }

    &.focus {
      border: 1px solid $theme-color;
      .floating-placeholder {
        color: $theme-primary;
      }

      .line {
        @include transform(scaleX(1) translateZ(0));
      }
    }

    &.float {
      .floating-placeholder {
        @include transform(translateY(-19px) scale(0.9));
      }

      input {
        @include transform(translateY(6px));
      }
    }

    &.disabled {
      textarea,
      .floating-placeholder {
        pointer-events: none;
        cursor: none;
        color: $color-grey-500;
      }
    }

    &.label {
      pointer-events: none;
      cursor: none;

      input {
        color: $color-grey-800;
      }

      .floating-placeholder {
        color: $color-grey-700;
      }
    }
  }

  .message {
    z-index: 1;
    font-size: 10px;
    color: $color-grey-500;
    line-height: 16px;
    height: 16px;
    padding: 0 16px;
    @include transform(translateY(-10px));
    opacity: 0;
    &.focus {
      color: $theme-primary;
      @include transform(translateY(0px));
      @include transition(all 0.2s $animation-sharp-curve-timing-function);
      opacity: 1;
    }
  }
}
</style>
